export default __webpack_public_path__ + "locales/el-GR/FillPDFDialog.json?hash=41d070e56c355b430de315547ba61a2d";